import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SiteNumberFunc } from '@ecp/common/src/const/site/siteNumberConst';
import { setCookie } from '@ecp/common/src/utils/cookieUtils';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { PageButton } from '@ecp/common/src/components/button/Button';

import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import { useAlertDialog } from '@mo-hooks/common/useModal';
import gatePageMopImage from '@ecp/common/src/assets/image/mop_mo_gate_page.jpg';
import authApi from '@mo-apis/common/authApi';

/**
 * MOP 우대코드 확인 페이지
 */
const MopGateCodePage = ({ onSuccess }) => {
  const { showAlertDialog } = useAlertDialog();
  const { siteNumber } = useSiteInfo();

  const [code, setCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cookieGateName = SiteNumberFunc.cookieGateName(siteNumber);

  const handleChangeCode = useCallback((event) => {
    event.target.value = event.target.value.replace(/\s/g, '');
    setCode(event.target.value);
  }, []);

  const handleSubmit = async () => {
    const trimmedCode = code.trim();

    if (!trimmedCode) {
      showAlertDialog('우대코드를 입력해 주세요.');
      return;
    }

    setIsSubmitting(true);

    try {
      const { result } = await authApi.getEventMallSpeByCode(trimmedCode);

      if (result) {
        const cookieValue = result + '|' + trimmedCode;

        setCookie(cookieGateName, cookieValue, {
          path: '/',
        });

        onSuccess?.();
      } else {
        showAlertDialog('유효한 우대코드가 아닙니다.');
      }
    } catch (error) {
      showAlertDialog(error?.response?.data?.message || '우대코드 조회시 오류가 발생했습니다.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageContainer width={'100%'} align-items={'center'}>
      <MopImageWrapper>
        <MopImage src={gatePageMopImage} alt={'웰스토리 고객사 복지몰 안내 이미지'} />
        <CodeFormArea>
          <CodeInput
            value={code}
            onChange={handleChangeCode}
            placeholder={'우대코드를 입력해 주세요'}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && !isSubmitting) {
                handleSubmit();
              }
            }}
          />
          <Spacing top={16} />
          <PageButton width={'320px'} height={'48px'} onClick={handleSubmit} disabled={isSubmitting}>
            입장하기
          </PageButton>
        </CodeFormArea>
      </MopImageWrapper>
      <Spacing top={80} />
    </PageContainer>
  );
};

MopGateCodePage.propTypes = {
  onSuccess: PropTypes.func,
};

const PageContainer = styled(FlexBoxColumn)`
  width: 100%;
  align-items: center;
  padding: 0 0 0;
  box-sizing: border-box;
`;

const MopImageWrapper = styled.div`
  position: relative;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
`;

const MopImage = styled.img`
  display: block;
  width: calc(100% + 68px);
  max-width: none;
  margin-left: -36px;
`;

const CodeFormArea = styled(FlexBoxColumn)`
  position: relative;
  z-index: 1;
  margin-top: -5px;
  align-items: center;
`;

const CodeInput = styled.input`
  width: 320px;
  height: 48px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 12px;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 15px;
  text-align: center;
`;

export default MopGateCodePage;
